import { useQuery } from '@tanstack/react-query';
import { useAppConfigContext } from '@/context/AppConfig';
import { CookiesStorage } from '@/storage/index';
import { throwResponseError } from '@/utils/index';
import { AccountResponse } from './Interfaces';

export const FETCH_ACCOUNT_ENDPOINT = '/api/v5/account';

async function fetchAccount() {
  const headers = new Headers({
    'content-type': 'application/x-www-form-urlencoded',
  });

  const response = await fetch(FETCH_ACCOUNT_ENDPOINT, {
    method: 'GET',
    headers,
  });

  if (response.ok) {
    const data = await response.json();
    return data;
  }
  await handleErrors(response);
}

async function handleErrors(response: Response) {
  if (response.status >= 400 && response.status < 500) {
    const data = await response.json();
    const message = data.errors[0];
    // Clearing cookie forces a logout based on the logged in check
    // currently. If this check changes, this will need to be updated
    // to properly remove session.
    const cookiesStorage = new CookiesStorage();
    cookiesStorage.removeValue('loggedin');
    window.location.reload();
    throwResponseError(message, response);
  } else {
    throwResponseError('Error fetching account', response);
  }
}

export function useAccount(isAuthenticated: boolean) {
  const { logError } = useAppConfigContext();

  return useQuery<AccountResponse, Error>({
    queryKey: ['account'],
    queryFn: fetchAccount,
    onError: (error) => {
      logError('Error fetching account', error);
    },
    enabled: isAuthenticated,
  });
}
